import { createSocketClient } from '@/shared/lib/socket/SharedWorkerClient';
import { coinoneRequest, toCoinoneTopicKey } from '@/shared/lib/socket/coinone-subscribe';

const COINONE_WS_URL = 'wss://stream.coinone.co.kr';

/**
 * TRAD-3635 — 코인원 공개 WS. 빗썸 소켓(bithumbSocket.ts)과 같은 모양이되 구독 형식이 다르다:
 * 워커가 `subscribeFormat: 'coinone'` 으로 종목별 SUBSCRIBE/UNSUBSCRIBE(차이만)와 JSON PING 을 보낸다(shared-worker.ts).
 * buildSubscribeMessage 는 SharedWorker 미지원 브라우저의 폴백(SocketManager) 경로용 — 종목별 요청 배열.
 * PING 30초(서버 유휴 종료 30분, 좀비 감시 PONG_TIMEOUT 45초 안쪽).
 */
const buildCoinoneSubscribeMessage = (type: string, codes: string[]) =>
  codes.map(code => JSON.parse(coinoneRequest('SUBSCRIBE', toCoinoneTopicKey(type, code))) as unknown);

export const coinoneSocketManager = createSocketClient({
  exchange: 'coinone',
  url: COINONE_WS_URL,
  buildSubscribeMessage: buildCoinoneSubscribeMessage,
  subscribeFormat: 'coinone',
  pingInterval: 30_000,
});
